import { render } from "./MultiSelectInput.vue?vue&type=template&id=0fe88f40"
import script from "./MultiSelectInput.vue?vue&type=script&lang=js"
export * from "./MultiSelectInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__